import { IGame } from "../Interfaces";

const kaleidoscope: IGame = {
  "name": "Kaleidoscope",
  "author": "Yihao",
  "time": new Date("2020-08-31T12:00:00.000Z"),
  "description": "This game mimics what one can see through a Kaleidoscope.",
  "refreshFrequency": 4,
  "width": 19,
  "height": 19,
  "seeds": [
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ]
  ],
  "surviveRangeLower": 3,
  "surviveRangeUpper": 6,
  "reproductionRangeLower": 1,
  "reproductionRangeUpper": 8,
  "borderPolicy": "roll",
  "styles": [
    [
      {
        "size": 0,
        "color": "#ffffff",
        "backgroundColor": "#eeeeee",
        "borderColor": "#333333",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 10,
        "color": "#fdc06f",
        "backgroundColor": "#eeeeee",
        "borderColor": "#333333",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 20,
        "color": "#fba0a0",
        "backgroundColor": "#eeeeee",
        "borderColor": "#333333",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 30,
        "color": "#91f091",
        "backgroundColor": "#eeeeee",
        "borderColor": "#333333",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 0
      },
      {
        "size": 40,
        "color": "#9adef4",
        "backgroundColor": "#eeeeee",
        "borderColor": "#333333",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 1
      },
      {
        "size": 50,
        "color": "#9aadf0",
        "backgroundColor": "#eeeeee",
        "borderColor": "#333333",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 2
      },
      {
        "size": 60,
        "color": "#b4c9db",
        "backgroundColor": "#eeeeee",
        "borderColor": "#333333",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 3
      },
      {
        "size": 70,
        "color": "#fadd83",
        "backgroundColor": "#eeeeee",
        "borderColor": "#333333",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 4
      },
      {
        "size": 80,
        "color": "#f65f5f",
        "backgroundColor": "#eeeeee",
        "borderColor": "#333333",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 5
      }
    ],
    [
      {
        "size": 100,
        "color": "#c72010",
        "backgroundColor": "#333333",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 6
      },
      {
        "size": 100,
        "color": "#f858b4",
        "backgroundColor": "#333333",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 7
      },
      {
        "size": 100,
        "color": "#cfa3ef",
        "backgroundColor": "#333333",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 8
      },
      {
        "size": 100,
        "color": "#a7f4ef",
        "backgroundColor": "#333333",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 9
      },
      {
        "size": 100,
        "color": "#31bd31",
        "backgroundColor": "#333333",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 10
      },
      {
        "size": 100,
        "color": "#9be548",
        "backgroundColor": "#333333",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 9
      },
      {
        "size": 100,
        "color": "#fdffa1",
        "backgroundColor": "#333333",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 8
      },
      {
        "size": 100,
        "color": "#fbd53b",
        "backgroundColor": "#333333",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 7
      },
      {
        "size": 100,
        "color": "#f9410d",
        "backgroundColor": "#333333",
        "borderColor": "gray",
        "borderRadius": 0,
        "borderWidth": 0,
        "elevation": 6
      }
    ]
  ]
};

export default kaleidoscope;